export function withBase(path) {
  const base = (process.env.PUBLIC_URL || "").replace(/\/$/, "");
  return `${base}${path.startsWith("/") ? path : `/${path}`}`;
}

const site = {
  name: "Rao Lokram Charitable Trust",
  hospital: "Rao Lokram Charitable Trust Hospital",
  origin: "https://abhishek16dev.github.io/hospitalwebsite",
  phoneDisplay: "98185 48492",
  phoneTel: "+919818548492",
  whatsapp:
    "https://wa.me/919818548492?text=" +
    encodeURIComponent(
      "Hello, I would like to ask about a visit to Rao Lokram Charitable Trust Hospital."
    ),
  phoneAltDisplay: "70423 28047",
  phoneAltTel: "+917042328047",
  labPhoneDisplay: "85859 66266",
  labPhoneTel: "+918585966266",
  email: "raolokramcharitabletrust@gmail.com",
  labEmail: "raolokram.charitable.lab@gmail.com",
  address:
    "Near Rockford School, Anaj Mandi Chowk, Kadipur Road, Shakti Park, Sector 10A, Gurugram, Haryana",
  hours: "Monday to Sunday, 9:00 AM – 5:00 PM",
  sundayOpd: "Sunday respiratory OPD 10:00 AM – 1:00 PM",
  instagram:
    "https://www.instagram.com/raolokramcharitable?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw==",
  facebook:
    "https://www.facebook.com/profile.php?id=100093212060201&mibextid=ZbWKwL",
  youtube: "https://youtube.com/@raolokramcharitabletrust?si=Ch8CIy1tSlPYoGO0",
  map: "https://maps.google.com/maps?q=Rao%20Lokram%20Charitable%20Trust%20Kadipur%20Road%20Sector%2010A%20Gurugram&z=16&output=embed",
  mapLink:
    "https://www.google.com/maps/search/?api=1&query=Rao+Lokram+Charitable+Trust+Sector+10A+Gurugram",
};

export default site;
